import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'

import { type ResCaseAlertItem } from '@/lib/queries/business/v1/alert/types'
import { cn } from '@/lib/utils'

import { EditAlertCard } from './edit-alert-card/edit-alert-card'
import { useUpdateAlertDialog } from './use-update-alert-dialog'

export interface UpdateAlertDialogProps {
  open: boolean
  alertData: ResCaseAlertItem
  onClose: VoidFunction
}

export const UpdateAlertDialog = ({ open, alertData, onClose }: UpdateAlertDialogProps) => {
  const { handleOpenChange } = useUpdateAlertDialog({ onClose })

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Alert</DialogTitle>
          <DialogDescription className={cn('sr-only')}>
            You can edit the alert to receive email notifications.
          </DialogDescription>
        </DialogHeader>

        <p className={cn('text-sm font-medium')}>
          Notification alerts will be sent via email only once, at 12:00 PM EST, on the day the alert is configured.
        </p>

        <EditAlertCard alertData={alertData} closeDialog={onClose} />
      </DialogContent>
    </Dialog>
  )
}
